const firebaseConfig = {
    apiKey: "AIzaSyBUtT76SoPoCTTy7UzBFJzUXaymVf1LzVM",
    authDomain: "assignment-10-e5999.firebaseapp.com",
    projectId: "assignment-10-e5999",
    storageBucket: "assignment-10-e5999.appspot.com",
    messagingSenderId: "764871522072",
    appId: "1:764871522072:web:823a46edfdcfb40ce0d06d",
    measurementId: "G-HLEYJKD2K0"
};
export default firebaseConfig;